import { LabeledRadioInput, LabeledTextInput, Label, TextEditor, useRequestInit } from "adviesbox-shared";
import React, { ReactElement, useState, useEffect } from "react";
import { StandaardtekstVoorOptions } from "../.generated/instellingen-forms/instellingen-formstypes";
import { getRapportageTags } from "../shared/components/rapportage/rapportage-tags-api";
import { ReplaceableTagInfo } from "../.generated/rapportage/rapportagetypes";

type StandaardTekstDetailsProps = { selected: number };

export const StandaardTekstDetails = (props: StandaardTekstDetailsProps): ReactElement => {
  const { selected } = props;
  const { settings, user } = useRequestInit();
  const [tags, setTags] = useState<ReplaceableTagInfo[]>([]);

  useEffect(() => {
    const fetchTags = async (): Promise<void> => {
      try {
        const fetchedTags = await getRapportageTags(settings, user);
        setTags(fetchedTags);
      } catch (error) {
        setTags([]);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchTags();
  }, [settings, user]);
  return (
    <>
      <LabeledRadioInput
        caption={"Standaardtekst voor"}
        name={`teksten[${selected}].tekstVoor`}
        options={[
          { label: "Ons advies", value: StandaardtekstVoorOptions.OnsAdvies },
          { label: "Afwijkende keuze", value: StandaardtekstVoorOptions.AfwijkendeKeuze }
        ]}
      />

      <LabeledTextInput caption="Korte omschrijving" name={`teksten[${selected}].korteOmschrijving`} />

      <div className="form-group form-row">
        <div className={`col-${5}`}>
          <Label caption={"Standaardtekst"} name={`teksten[${selected}].standaardTekst`} />
        </div>
        <div className={`col-${6}`}>
          {tags.length > 0 && (
            <TextEditor
              key={selected}
              name={`teksten[${selected}].standaardTekst`}
              useTextEditor={true}
              rows={5}
              tags={
                tags.map(tagInfo => ({
                  label: tagInfo.description || tagInfo.tag || "",
                  value: tagInfo.tag || ""
                })) as any
              }
            />
          )}
        </div>
      </div>
    </>
  );
};
